import MaterialStock from "./MaterialStock";

export default function SalesInvoices() {
  return <MaterialStock forcedEntryType="sale" />;
}
